import { Box, SxProps } from 'components/base';
import { NoDataSvg } from 'pages/Forms/FormIcons/FormIcons';

const NoDataContainer: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 10,
};

const NoResponseData = ({ subtitle }: { subtitle: string }) => (
  <Box sx={NoDataContainer}>
    <NoDataSvg
      title="This form has no questions right now"
      subTitle={subtitle || ''}
    />
  </Box>
);

export default NoResponseData;
